import React, { useEffect, useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./NovaLanding.css";
import "./PrivacyPolicy.css";

export default function Eula() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [navShadow, setNavShadow] = useState(false);

  useLayoutEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      const scrollingElement = document.scrollingElement;
      if (scrollingElement) {
        scrollingElement.scrollTop = 0;
      }

      const root = document.getElementById("root");
      if (root) {
        root.scrollTop = 0;
      }
    };

    scrollToTop();
    const animationFrame = window.requestAnimationFrame(scrollToTop);
    const timeout = window.setTimeout(scrollToTop, 0);

    return () => {
      window.cancelAnimationFrame(animationFrame);
      window.clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setNavShadow(window.scrollY > 6);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleNav = () => {
    setMobileMenuOpen((open) => !open);
  };

  return (
    <div className="privacy-page" data-testid="eula-page">
      <header id="nav" style={{ boxShadow: navShadow ? "0 2px 24px rgba(0,0,0,.35)" : "none" }}>
        <div className="container ni">
          <Link to="/landing" className="nl" aria-label="Nova landing page" data-testid="eula-nav-logo-link">
            <img src="https://nova.bizacuity.ai/nova-logo.png" alt="Nova" style={{
                height: "30px",
                filter: "brightness(0) invert(1)",
                opacity: 0.8,
              }}/>
          </Link>
          <nav className="nls">
            <Link to="/landing#feat" data-testid="eula-nav-features-link">Features</Link>
            <Link to="/landing#how" data-testid="eula-nav-how-it-works-link">How It Works</Link>
            <Link to="/landing#integ" data-testid="eula-nav-integrations-link">Integrations</Link>
            <Link to="/landing#price" data-testid="eula-nav-pricing-link">Pricing</Link>
            <a href="nova-contact.html" data-testid="eula-nav-contact-link">Contact</a>
          </nav>
          <div className="na">
            <Link className="nsi" to="/" data-testid="eula-nav-sign-in-link">
              Sign In
            </Link>
            <Link className="nsi" to="/signup" data-testid="eula-nav-sign-up-link">
              Sign Up
            </Link>
            <Link className="nc" to="/landing" data-testid="eula-nav-request-demo-link">
              Request Demo
            </Link>
          </div>
          <button className="hbg" onClick={toggleNav} aria-label="Toggle navigation" aria-expanded={mobileMenuOpen} data-testid="eula-nav-mobile-menu-toggle-button">
            <svg viewBox="0 0 24 24">
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
        <div id="mn" style={{ display: mobileMenuOpen ? "block" : "none" }}>
          <Link to="/landing#feat" onClick={toggleNav} data-testid="eula-nav-mobile-features-link">
            Features
          </Link>
          <Link to="/landing#how" onClick={toggleNav} data-testid="eula-nav-mobile-how-it-works-link">
            How It Works
          </Link>
          <Link to="/landing#integ" onClick={toggleNav} data-testid="eula-nav-mobile-integrations-link">
            Integrations
          </Link>
          <Link to="/landing#price" onClick={toggleNav} data-testid="eula-nav-mobile-pricing-link">
            Pricing
          </Link>
          <a href="nova-contact.html" onClick={toggleNav} data-testid="eula-nav-mobile-contact-link">
            Contact
          </a>
          <div className="mobile-auth-actions">
            <Link className="mobile-auth-button mobile-auth-secondary" to="/" onClick={toggleNav} data-testid="eula-nav-mobile-sign-in-link">
              Sign In
            </Link>
            <Link className="mobile-auth-button mobile-auth-secondary" to="/signup" onClick={toggleNav} data-testid="eula-nav-mobile-sign-up-link">
              Sign Up
            </Link>
          </div>
          <Link className="btn bb privacy-mobile-demo-link" to="/landing" onClick={toggleNav} data-testid="eula-nav-mobile-request-demo-link">
            Request Demo
          </Link>
        </div>
      </header>

      <main className="privacy-main">
        <section className="privacy-hero">
          <p className="privacy-eye">Legal</p>
          <h1>End User License Agreement</h1>
          <p className="privacy-subtitle">Last updated: April 2026</p>
        </section>

        <aside className="privacy-toc">
          <h3>Contents</h3>
          <ol>
            <li><a href="#e1" data-testid="eula-toc-agreement-to-terms-link">1. Agreement to Terms</a></li>
            <li><a href="#e2" data-testid="eula-toc-definitions-link">2. Definitions</a></li>
            <li><a href="#e3" data-testid="eula-toc-license-grant-link">3. License Grant</a></li>
            <li><a href="#e4" data-testid="eula-toc-license-restrictions-link">4. License Restrictions</a></li>
            <li><a href="#e5" data-testid="eula-toc-accounts-tenant-administration-link">5. Accounts &amp; Tenant Administration</a></li>
            <li><a href="#e6" data-testid="eula-toc-subscription-fees-credits-link">6. Subscription, Fees &amp; Credits</a></li>
            <li><a href="#e7" data-testid="eula-toc-customer-content-data-license-link">7. Customer Content &amp; Data License</a></li>
            <li><a href="#e8" data-testid="eula-toc-ai-generated-output-link">8. AI-Generated Output</a></li>
            <li><a href="#e9" data-testid="eula-toc-third-party-services-components-link">9. Third-Party Services &amp; Components</a></li>
            <li><a href="#e10" data-testid="eula-toc-intellectual-property-link">10. Intellectual Property</a></li>
            <li><a href="#e11" data-testid="eula-toc-confidentiality-link">11. Confidentiality</a></li>
            <li><a href="#e12" data-testid="eula-toc-disclaimer-of-warranties-link">12. Disclaimer of Warranties</a></li>
            <li><a href="#e13" data-testid="eula-toc-limitation-of-liability-link">13. Limitation of Liability</a></li>
            <li><a href="#e14" data-testid="eula-toc-indemnification-link">14. Indemnification</a></li>
            <li><a href="#e15" data-testid="eula-toc-term-termination-link">15. Term &amp; Termination</a></li>
            <li><a href="#e16" data-testid="eula-toc-export-compliance-link">16. Export Compliance</a></li>
            <li><a href="#e17" data-testid="eula-toc-governing-law-dispute-resolution-link">17. Governing Law &amp; Dispute Resolution</a></li>
            <li><a href="#e18" data-testid="eula-toc-general-provisions-link">18. General Provisions</a></li>
            <li><a href="#e19" data-testid="eula-toc-contact-link">19. Contact</a></li>
          </ol>
        </aside>

        <section className="privacy-section" id="e1">
          <h2>1. Agreement to Terms</h2>
          <p>
            This End User License Agreement (&quot;<strong>Agreement</strong>&quot; or &quot;<strong>EULA</strong>&quot;) is a binding
            legal agreement between you, acting individually or on behalf of an organisation
            (&quot;<strong>Customer</strong>&quot;, &quot;<strong>you</strong>&quot;), and BizAcuity
            Solutions Pvt Ltd (&quot;<strong>BizAcuity</strong>&quot;, &quot;<strong>we</strong>&quot;, &quot;<strong>us</strong>&quot;),
            a company incorporated in India with its registered office in Hyderabad, India,
            the licensor of the Nova platform. It governs your access to and use of Nova&apos;s hosted
            software-as-a-service application, associated APIs, embeddable widgets, and documentation
            (collectively, the &quot;<strong>Software</strong>&quot;).
          </p>
          <p>
            By creating an account, clicking &quot;I Agree&quot;, installing an integration, or otherwise
            accessing or using the Software, you accept this Agreement on your own behalf and, if
            applicable, on behalf of the organisation you represent, and you represent that you have
            authority to bind that organisation. If you do not agree to this Agreement, you must not
            access or use the Software. This Agreement supplements, and should be read together with,
            Nova&apos;s <Link to="/termsandconditions">Terms &amp; Conditions</Link> and{" "}
            <Link to="/privacypolicy">Privacy Policy</Link>; in the event of a direct conflict between
            this Agreement and the Terms &amp; Conditions on matters of software licensing, this
            Agreement governs.
          </p>
        </section>

        <section className="privacy-section" id="e2">
          <h2>2. Definitions</h2>
          <ul>
            <li><strong>&quot;Authorised User&quot;</strong> means an individual whom Customer permits to access the Software under Customer&apos;s account, such as an employee or administrator.</li>
            <li><strong>&quot;Customer Content&quot;</strong> means documents, files, messages, code repositories, and other data that Customer or its Authorised Users upload to or generate within the Software.</li>
            <li><strong>&quot;Order&quot;</strong> means a subscription order, order form, or online plan selection referencing this Agreement.</li>
            <li><strong>&quot;Tenant&quot;</strong> means the isolated workspace and data environment provisioned for Customer within the Software.</li>
          </ul>
        </section>

        <section className="privacy-section" id="e3">
          <h2>3. License Grant</h2>
          <p>
            Subject to Customer&apos;s continued compliance with this Agreement and payment of
            applicable fees, BizAcuity grants Customer a limited, non-exclusive, non-transferable,
            non-sublicensable, revocable licence, during the applicable subscription term, to:
          </p>
          <ul>
            <li>access and use the Software solely for Customer&apos;s internal business purposes;</li>
            <li>permit its Authorised Users to access and use the Software in accordance with the roles and permissions Customer configures; and</li>
            <li>embed Nova&apos;s widget on websites or applications that Customer owns or controls, where that feature is enabled on Customer&apos;s plan.</li>
          </ul>
          <p>No ownership rights are transferred under this Agreement. All rights not expressly granted are reserved by BizAcuity.</p>
        </section>

        <section className="privacy-section" id="e4">
          <h2>4. License Restrictions</h2>
          <p>Customer shall not, and shall not permit any Authorised User or third party to:</p>
          <ul>
            <li>copy, modify, translate, or create derivative works of the Software;</li>
            <li>reverse engineer, decompile, or disassemble the Software, except to the extent such restriction is prohibited by applicable law;</li>
            <li>sell, resell, rent, lease, sublicense, or otherwise make the Software available to any third party outside of Customer&apos;s own organisation, except through the embeddable widget as expressly permitted;</li>
            <li>circumvent or disable rate limits, content guardrails, authentication, or other technical restrictions in the Software;</li>
            <li>use the Software to build, train, or benchmark a competing product or service; or</li>
            <li>remove, obscure, or alter any proprietary notices on the Software.</li>
          </ul>
        </section>

        <section className="privacy-section" id="e5">
          <h2>5. Accounts &amp; Tenant Administration</h2>
          <p>
            Customer is responsible for all activity occurring under its Tenant, for configuring
            appropriate roles and access controls for Authorised Users, and for maintaining the
            confidentiality of account credentials. Customer must promptly notify BizAcuity of any
            suspected unauthorised access.
          </p>
        </section>

        <section className="privacy-section" id="e6">
          <h2>6. Subscription, Fees &amp; Credits</h2>
          <p>
            Use of the Software beyond any free trial or free tier requires an active, paid
            subscription and, where applicable, sufficient usage credits. Fees, billing cycles,
            usage-based credit consumption, and renewal terms are as set out in the applicable Order
            or plan and Nova&apos;s <Link to="/termsandconditions">Terms &amp; Conditions</Link>.
            BizAcuity may suspend access to the Software for accounts with expired subscriptions,
            exhausted credits, or overdue payment, subject to the notice periods described in the
            Terms &amp; Conditions.
          </p>
        </section>

        <section className="privacy-section" id="e7">
          <h2>7. Customer Content &amp; Data License</h2>
          <p>
            As between the parties, Customer retains all right, title, and interest in Customer
            Content. Customer grants BizAcuity a limited, non-exclusive licence to host, process,
            transmit, and display Customer Content solely to provide, maintain, secure, and support
            the Software, and as otherwise described in Nova&apos;s{" "}
            <Link to="/privacypolicy">Privacy Policy</Link>. BizAcuity does not use Customer Content
            to train foundation AI models. Customer is solely responsible for ensuring it has the
            rights necessary to upload Customer Content and that doing so complies with applicable
            law.
          </p>
        </section>

        <section className="privacy-section" id="e8">
          <h2>8. AI-Generated Output</h2>
          <p>
            The Software uses third-party large language models and retrieval-augmented generation
            over Customer Content to produce chat responses, summaries, and other output
            (&quot;<strong>Output</strong>&quot;). Output is generated automatically and may be
            incomplete, inaccurate, or unsuitable for a particular purpose. Output does not
            constitute legal, financial, medical, HR, or other professional advice. Customer is
            responsible for reviewing Output before relying on it or acting upon it, and for
            complying with any laws applicable to its use, including in employment-related
            decisions.
          </p>
        </section>

        <section className="privacy-section" id="e9">
          <h2>9. Third-Party Services &amp; Components</h2>
          <p>
            The Software is built on and interoperates with third-party infrastructure and services,
            including cloud hosting, authentication, storage, and AI model providers, and - where
            Customer enables them - integrations such as Google Workspace, Google Chat, and GitHub.
            Customer&apos;s use of such integrations is also subject to the applicable third party&apos;s
            terms. BizAcuity is not responsible for the availability, acts, or omissions of
            third-party services outside its reasonable control.
          </p>
        </section>

        <section className="privacy-section" id="e10">
          <h2>10. Intellectual Property</h2>
          <p>
            The Software, including its underlying source code, architecture, models, prompts,
            branding, and documentation, is and remains the exclusive property of BizAcuity and its
            licensors. This Agreement does not grant Customer any right to BizAcuity&apos;s trademarks,
            logos, or other brand features except as necessary to use the Software as intended.
            Feedback that Customer voluntarily provides about the Software may be used by BizAcuity
            without restriction or obligation.
          </p>
        </section>

        <section className="privacy-section" id="e11">
          <h2>11. Confidentiality</h2>
          <p>
            Each party may receive confidential information of the other party in connection with
            this Agreement. Each party agrees to protect the other&apos;s confidential information using
            at least the same degree of care it uses for its own confidential information of similar
            nature, and not less than a reasonable degree of care, and to use such information only
            to perform its obligations or exercise its rights under this Agreement.
          </p>
        </section>

        <section className="privacy-section" id="e12">
          <h2>12. Disclaimer of Warranties</h2>
          <p>
            THE SOFTWARE IS PROVIDED &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot;, WITHOUT WARRANTIES OF ANY
            KIND, WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. BIZACUITY DOES NOT
            WARRANT THAT THE SOFTWARE WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE, OR THAT OUTPUT
            WILL BE ACCURATE OR COMPLETE. NO ADVICE OR INFORMATION OBTAINED FROM BIZACUITY OR
            THROUGH THE SOFTWARE SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THIS AGREEMENT.
          </p>
        </section>

        <section className="privacy-section" id="e13">
          <h2>13. Limitation of Liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, NEITHER PARTY SHALL BE LIABLE FOR ANY
            INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF
            PROFITS, REVENUE, DATA, OR GOODWILL, ARISING OUT OF OR RELATED TO THIS AGREEMENT OR THE
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. BIZACUITY&apos;S TOTAL
            AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT SHALL NOT EXCEED THE
            FEES PAID BY CUSTOMER TO BIZACUITY FOR THE SOFTWARE IN THE TWELVE (12) MONTHS PRECEDING
            THE EVENT GIVING RISE TO THE CLAIM. THESE LIMITATIONS APPLY REGARDLESS OF THE LEGAL
            THEORY ON WHICH A CLAIM IS BASED AND EVEN IF A REMEDY FAILS OF ITS ESSENTIAL PURPOSE.
            NOTHING IN THIS AGREEMENT LIMITS LIABILITY THAT CANNOT BE LIMITED UNDER APPLICABLE LAW.
          </p>
        </section>

        <section className="privacy-section" id="e14">
          <h2>14. Indemnification</h2>
          <p>
            Customer agrees to indemnify, defend, and hold harmless BizAcuity and its officers,
            employees, and agents from and against any third-party claims, damages, liabilities, and
            expenses (including reasonable legal fees) arising from Customer Content, Customer&apos;s
            breach of this Agreement, or Customer&apos;s violation of applicable law in its use of the
            Software.
          </p>
        </section>

        <section className="privacy-section" id="e15">
          <h2>15. Term &amp; Termination</h2>
          <p>
            This Agreement remains in effect for as long as Customer holds an active account or
            subscription. BizAcuity may suspend or terminate Customer&apos;s access immediately upon
            material breach of this Agreement, including violations of the license restrictions in
            Section 4, non-payment, or unlawful use of the Software. Upon termination, the licence
            granted under Section 3 ends immediately, and Customer must cease all use of the
            Software. Sections that by their nature should survive termination (including
            Sections 4, 7, 10–14, and 17) shall survive.
          </p>
        </section>

        <section className="privacy-section" id="e16">
          <h2>16. Export Compliance</h2>
          <p>
            Customer shall comply with all applicable trade control and export laws in its use of
            the Software, and represents that it is not located in, or a national of, any country
            subject to comprehensive trade sanctions, and is not listed on any applicable restricted
            party list.
          </p>
        </section>

        <section className="privacy-section" id="e17">
          <h2>17. Governing Law &amp; Dispute Resolution</h2>
          <p>
            This Agreement is governed by the laws of India, without regard to its conflict-of-laws
            principles. Subject to any mandatory consumer-protection law to the contrary, the courts
            at Hyderabad, India shall have exclusive jurisdiction over any dispute
            arising out of or relating to this Agreement. The parties will first attempt to resolve
            any dispute through good-faith negotiation before initiating formal proceedings.
          </p>
        </section>

        <section className="privacy-section" id="e18">
          <h2>18. General Provisions</h2>
          <ul>
            <li><strong>Entire Agreement.</strong> This Agreement, together with the Terms &amp; Conditions, Privacy Policy, and any Order, constitutes the entire agreement between the parties regarding the Software and supersedes all prior agreements on the subject.</li>
            <li><strong>Amendments.</strong> BizAcuity may update this Agreement from time to time; material changes will be notified as described in the Terms &amp; Conditions. Continued use of the Software after changes take effect constitutes acceptance.</li>
            <li><strong>Assignment.</strong> Customer may not assign this Agreement without BizAcuity&apos;s prior written consent. BizAcuity may assign this Agreement in connection with a merger, acquisition, or sale of substantially all its assets.</li>
            <li><strong>Severability.</strong> If any provision of this Agreement is held unenforceable, the remaining provisions remain in full force and effect.</li>
            <li><strong>No Waiver.</strong> Failure to enforce any provision of this Agreement is not a waiver of that provision.</li>
            <li><strong>Force Majeure.</strong> Neither party is liable for delays or failures caused by events beyond its reasonable control.</li>
          </ul>
        </section>

        <section className="privacy-section" id="e19">
          <h2>19. Contact</h2>
          <p>
            For questions about this Agreement, contact us at{" "}
            <a href="mailto:chatbot.bizacuity@bizacuity.ai">chatbot.bizacuity@bizacuity.ai</a> or visit our{" "}
            <a href="nova-contact.html">contact page</a>.
          </p>
        </section>
      </main>

      <footer className="privacy-footer">
        <p>
          <Link to="/landing" data-testid="eula-footer-home-link">Home</Link>
          <Link to="/privacypolicy" data-testid="eula-footer-privacy-policy-link">Privacy Policy</Link>
          <Link to="/termsandconditions" data-testid="eula-footer-terms-link">Terms &amp; Conditions</Link>
          <a href="nova-contact.html" data-testid="eula-footer-contact-link">Contact</a>
        </p>
        <p className="privacy-footer-copy">© {new Date().getFullYear()} Nova by BizAcuity. All rights reserved.</p>
      </footer>
    </div>
  );
}
